let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dO74n")).then(() => parcelRequire('aVnDh'));